import { createReducer, on } from '@ngrx/store';
import { CompanyGroupState, initialCompanyGroupState } from './company-group.state';
import * as CompanyGroupActions from './company-group.actions';

export const companyGroupReducer = createReducer(
  initialCompanyGroupState,

  on(CompanyGroupActions.loadCompanyGroups, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(CompanyGroupActions.loadCompanyGroupsSuccess, (state, { companyGroups }) => ({
    ...state,
    companyGroups,
    loading: false,
    error: null,
  })),

  on(CompanyGroupActions.loadCompanyGroupsPaginated, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(CompanyGroupActions.loadCompanyGroupsPaginatedSuccess, (state, { items, total }) => ({
    ...state,
    companyGroups: items,
    total,
    loading: false,
    error: null,
  })),

  on(CompanyGroupActions.companyGroupFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(CompanyGroupActions.deleteCompanyGroupSuccess, (state, { id }) => ({
    ...state,
    companyGroups: state.companyGroups.filter(group => group.id !== id)
  })),

  on(CompanyGroupActions.searchCompanyGroupsSuccess, (state, { results }) => ({
  ...state,
  searchResults: results,
}))
);
